var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.4898 7.86408V6.02913C8.4898 4.98058 9.28571 4.71845 9.81633 4.71845H13V0H8.4898C3.71429 0 2.65306 3.40777 2.65306 5.76699V8.12621H0V11.2718V13.3689H2.65306V27H8.22449V13.3689H12.2041L12.4694 11.2718L12.7347 7.86408H8.4898Z","fill":"#000F32","key":0}),React.createElement("path",{"d":"M8.4898 7.86408V6.02913C8.4898 4.98058 9.28571 4.71845 9.81633 4.71845H13V0H8.4898C3.71429 0 2.65306 3.40777 2.65306 5.76699V8.12621H0V11.2718V13.3689H2.65306V27H8.22449V13.3689H12.2041L12.4694 11.2718L12.7347 7.86408H8.4898Z","stroke":"#000F32","key":1})]);
}

Facebook.defaultProps = {"width":"13","height":"27","viewBox":"0 0 13 27","fill":"none","title":"Facebook"};

module.exports = Facebook;

Facebook.default = Facebook;
